<template>
    <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de Sinistros Pagamento</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div>
                                    <a href="#" class="btn btn-secondary" style="padding: 5px;margin: 5px;font-size: 12px;" @click="SelecionaSituacao(10)">Aguardando Pagamento</a>
                                     <a href="#" class="btn btn-secondary" style="padding: 5px;margin: 5px;font-size: 12px;" @click="SelecionaSituacao(20)">Pagamento Agendado</a>
                                      <a href="#" class="btn btn-secondary" style="padding: 5px;margin: 5px;font-size: 12px;" @click="SelecionaSituacao(30)">Pagamento Efetuado</a>
                                </div>
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table v-if="ListSinistros!=''" :headers="headers" :items="ListSinistros"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina"
                                    :search-value="searchValue">
                                    <template #item-snpDtInclusao="item">
                                        <span> {{ item.snpDtInclusao !== null ? formattedDate(item.snpDtInclusao) : null }}</span>
                                    </template>
                                       <template #item-snpDtPagamento="item">
                                        <span> {{ item.snpDtPagamento !== null ? formattedDate(item.snpDtPagamento) : null }}</span>
                                    </template>
                                     <template #item-snpDtAgendamento="item">
                                        <span> {{ item.snpDtAgendamento !== null ? formattedDate(item.snpDtAgendamento) : null }}</span>
                                    </template>
                                      <template #item-snpValor="item">
                                        <span> {{ item.snpValor !== null ? formatarValor(item.snpValor) : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaSinistrosPagamentoView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        itemsSelected: [],
        searchValue: '',
        MostraGrid: true,
        headers: [],
        ListSinistros:[],
        ListSinistrosGeral:[],
    }),
    methods: {
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListSinistros = this.ListSinistrosGeral.filter(x=> x.pstIdAtual == value);
            }
            else{
                this.ListSinistros = this.ListSinistrosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditGrid(item) {
            this.$router.push('/sinistropagamentodetalhe/' + item.sntIdCript);
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Id", value: "sntCodigo", sortable: true, });
            this.headers.push({ text: "Data Inclusão", value: "snpDtInclusao", sortable: true, });
             this.headers.push({ text: "Data Agendamento", value: "snpDtAgendamento", sortable: true, });
            this.headers.push({ text: "Data Pagamento", value: "snpDtPagamento", sortable: true, });
             this.headers.push({ text: "Contratacao", value: "pedId", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imoNome", sortable: true, });
            }
            this.headers.push({ text: "Cliente", value: "pedDescricao", sortable: true, });
             this.headers.push({ text: "Valor", value: "snpValor", sortable: true, });
            this.headers.push({ text: "Situação", value: "pstNome", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        async Get() {
              await axios.get(`/Telas/ListaSinistrosPagamento/GetDados`)
                .then(response => {
                    this.ListSinistrosGeral = response.data.sinistroPagamento.sort(
                        (a, b) => (b.snpDtInclusao || '').localeCompare(a.snpDtInclusao || '')
                        );
                    this.ListSinistros = this.ListSinistrosGeral;
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;

                
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
</style>
